import { isGlobalworth } from 'config'
import { Paper, PaperProps, styled } from '@mui/material'
import { ReactNode } from 'react'

type PropsWithChildren<P = unknown> = PaperProps & P & { children: ReactNode }

const Wrapper = styled(Paper)(({ theme }) => ({
  boxSizing: 'border-box',
  paddingBottom: theme.spacing(4),
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  padding: '24px',
  boxShadow: 'none',
  borderRadius: isGlobalworth ? '0px' : '16px',
  border: isGlobalworth ? `1px solid ${theme.palette.grey[500]}` : 'none',
  [theme.breakpoints.down('md')]: {
    padding: '14px',
  },
}))

const ContentWrapper = ({ children, ...rest }: PropsWithChildren) => (
  <Wrapper {...rest}>{children}</Wrapper>
)

export default ContentWrapper
